import { render, staticRenderFns } from "./trainingTabbar.vue?vue&type=template&id=96ff8ed6&scoped=true&"
import script from "./trainingTabbar.vue?vue&type=script&lang=js&"
export * from "./trainingTabbar.vue?vue&type=script&lang=js&"
import style0 from "./trainingTabbar.vue?vue&type=style&index=0&id=96ff8ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff8ed6",
  null
  
)

export default component.exports